import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFacebook, faSquareInstagram } from '@fortawesome/free-brands-svg-icons';

import './App.css';
import img1 from './images/img1.png';
import img2 from './images/img2.png';
import img3 from './images/img3.png';

function App() {
  const [prevImage, setPrevImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [votes, setVotes] = useState({ img1: 0, img2: 0, img3: 0 });
  const [totalVotes, setTotalVotes] = useState(0);

  // Cambia questo URL con il percorso dell'API PHP nel tuo hosting
  const BASE_URL = window.location.origin;
  //const BASE_URL = 'https://voting-bigo.test/';
  const API_URL = `${BASE_URL}/contestbigo/api/voting-api.php`;
  
  // Funzione per ottenere i risultati
  const getResults = () => {
    fetch(API_URL)
      .then((response) => response.json())
      .then((data) => {
        setVotes(data);
        const total = data.img1 + data.img2 + data.img3;
        setTotalVotes(total);
      });
  };

  // Richiama i risultati ogni 5 secondi
  useEffect(() => {
    getResults();
    const interval = setInterval(getResults, 5000);
    return () => clearInterval(interval); // Pulizia al cambio di componente
  }, []);

  // Funzione per inviare il voto
  const submitVote = () => {
    if (selectedImage === null) {
      alert('Seleziona un\'immagine prima di votare!');
      return;
    }

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ 
        imageId: selectedImage,
        prevImage: prevImage
      }),
    })
      .then((response) => response.json())
      .then((data) => {

        setPrevImage(selectedImage);
        alert(data.message);

        if (data.success) {
          getResults();
        }
      })
      .catch((error) => {
        console.error('Errore:', error);
      });
  };

  // Funzione per calcolare la percentuale
  const getPercentage = (imgVotes) => {
    return totalVotes > 0 ? Math.round((imgVotes / totalVotes) * 100) : 0;
  };

  return (
    <div className="App">
      <h1>VOTA</h1>
      <div className="images">
        <div className="image-container blue-card">
          <div className="card-container">
            <img
              src={img1}
              alt="Immagine 1"
            />
            <div className='card-text'>
              <h2>Giulio</h2>
              <p>Anni: 5</p>
              <p>Superpotere:</p>
              <p>Controllo del fuoco</p> 
            </div>
            <input
              type="radio"
              checked={selectedImage === 1}
              onChange={() => setSelectedImage(1)}
            />
          </div>
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: getPercentage(votes.img1) + '%' }}
            >
              {getPercentage(votes.img1)}%
            </div>
          </div>
        </div>
        <div className="image-container pink-card">
          <div className="card-container">
            <img
              src={img2}
              alt="Immagine 2"
            />
            <div className='card-text'>
              <h2>Sara</h2>
              <p>Anni: 6</p>
              <p>Superpotere:</p>
              <p>Levitazione</p> 
            </div>
            <input
              type="radio"
              checked={selectedImage === 2}
              onChange={() => setSelectedImage(2)}
            />
          </div>
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: getPercentage(votes.img2) + '%' }}
            >
              {getPercentage(votes.img2)}%
            </div>
          </div>
        </div>
        <div className="image-container green-card">
          <div className="card-container">
            <img
              src={img3}
              alt="Immagine 3"
            />
            <div className='card-text'>
              <h2>Davide</h2>
              <p>Anni: 6</p>
              <p>Superpotere:</p>
              <p>Superforza</p> 
            </div>
            <input
              type="radio"
              checked={selectedImage === 3}
              onChange={() => setSelectedImage(3)}
            />
          </div>
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: getPercentage(votes.img3) + '%' }}
            >
              {getPercentage(votes.img3)}%
            </div>
          </div>
        </div>
      </div>
      <button onClick={submitVote}>VOTA</button>

      <footer>
        <h3>Segui i nostri social per scoprire il vincitore</h3>
        <div className='divSocial'>
          <a href='https://www.facebook.com/CooperativaLaLuce'>
            <FontAwesomeIcon icon={faSquareFacebook} size="2xl" style={{color: "#3b5998",}} />
            <p style={{color: "black",}}><b>Cooperativa la luce</b></p>
          </a>
          <a href='https://www.instagram.com/bigo.officialart/'>
            <FontAwesomeIcon icon={faSquareInstagram} size="2xl" style={{color: "#bc2a8d",}}/>
            <p style={{color: "black",}}><b>Bigo.officialart</b></p>
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
